/* global axios */
import ApiClient from './ApiClient';

class ContactMeetings extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/meeting`;
  }

  schedule(contactId, { provider, startAt, assignedAgentId }) {
    this.contactId = contactId;
    return axios.post(this.url, {
      provider,
      start_at: startAt,
      assigned_agent_id: assignedAgentId,
    });
  }

  reschedule(contactId, { startAt }) {
    this.contactId = contactId;
    return axios.patch(this.url, { start_at: startAt });
  }

  cancel(contactId) {
    this.contactId = contactId;
    return axios.delete(this.url);
  }
}

export default new ContactMeetings();
